import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import Avatar from 'components/Avatar/Avatar';
import NavigationMenu from 'components/NavigationMenu/NavigationMenu';
import Panel from 'components/Panel/Panel';

import { useAuth } from 'utils/auth';

import styles from './app-layout.scss';

export default function AppLayout() {
    const auth = useAuth();

    return (
        <>
            <Panel
                style={{ flexShrink: 0, background: 'transparent' }}
                contentStyles={{ padding: '0 16px', width: 192 }}
            >
                <div className={styles.company}>
                    <NavLink to="/companies">
                        <div className={styles.wrapper}>
                            <Avatar text={auth.company.name} />
                            <h2>{auth.company.name}</h2>
                        </div>
                    </NavLink>
                </div>
                <NavigationMenu />
            </Panel>
            <Outlet />
        </>
    );
}
